import { getTypographyMetric, getTypographyMetricOverride } from '../../../../helpers';
import { useTheme } from 'styled-components';
import { Flex } from 'front-commons/ds/components/Flex';
import { Button } from 'front-commons/ds/components/Button';
import { Icon, Loading } from 'front-commons/ds/components';
import { Typography } from 'hype-ds';
import { OpenBasketButtonProps } from './interfaces';

export function OpenBasketButton({ basketData, loadingBasket, handleOpenBasket }: OpenBasketButtonProps) {
	const { fontSizes } = useTheme();

	return (
		<Flex
			as={Button}
			display="flex"
			gap="8px"
			alignItems="center"
			justifyContent="center"
			position="relative"
			noShrink={true}
			borderRadius="8px"
			overflow="visible"
			raw={{
				'&&': {
					borderRadius: '8px',
					overflow: 'visible',
					"&[data-variant='none']": { padding: '0.5rem' },
					'&:hover': { backgroundColor: 'var(--surface-accent-light)' },
				},
			}}
			data-testid="cart-button"
			onClick={handleOpenBasket}
			variant="none"
		>
			<Icon color="--text-link" fill name="shopping_cart" size="24px" />

			{loadingBasket && (
				<Flex
					display="grid"
					gap="normal"
					top="3px"
					right="4px"
					position="absolute"
					raw={{
						placeItems: 'center',
						sup: {
							padding: '2px',
							borderRadius: '2px',
							lineHeight: '10px',
							color: 'var(--surface-white)',
							backgroundColor: 'var(--red-600)',
						},
					}}
					data-testid="cart-icon-loading"
				>
					<Loading size="12" />
				</Flex>
			)}

			{!loadingBasket && !!basketData.totalItems && (
				<Flex
					display="grid"
					gap="normal"
					top="3px"
					right="4px"
					position="absolute"
					raw={{
						placeItems: 'center',
						sup: {
							padding: '2px',
							borderRadius: '2px',
							lineHeight: '10px',
							color: 'var(--surface-white)',
							backgroundColor: 'var(--red-600)',
						},
						"[data-header-text='OpenBasketButton-text-1']": {
							display: 'inline',
							fontSize: getTypographyMetricOverride(fontSizes['14']),
						},
					}}
					data-testid="cart-icon-amount"
				>
					<Typography
						textAlign="inherit"
						fontSize={getTypographyMetric(fontSizes['14'])}
						fontWeight="600"
						lineHeight="10px"
						as="sup"
						color="--greys-white"
						data-header-text="OpenBasketButton-text-1"
					>
						{basketData.totalItems > 99 ? '99' : basketData.totalItems}
					</Typography>
				</Flex>
			)}
		</Flex>
	);
}
